import React from "react";
import { Line } from "@ant-design/plots";

const DynamicLineChart = ({ data, xField, yField, seriesField, title, isMaximized }) => {
  const config = {
    data,
    xField,
    yField,
    seriesField,
    smooth: true,
    autoFit: true,
    height: isMaximized ? 500 : 200,
    // height: 140, // ✅ chart height
    label: false,
    point: {
      size: 5,
      shape: "circle",
    },
    meta: {
      [xField]: { alias: xField },
      [yField]: { alias: yField },
    },
  };

  return (
    <div className="my-4" style={{ width: "100%", height: "70%" }}>
      {title && <h3 className="text-center mb-2">{title}</h3>}
      <Line {...config} />
    </div>
  );
};

export default DynamicLineChart;
